<template>
  <div class="label">{{ name }}</div>
  <v-item-group
    :multiple="multiple ? true : false"
    v-model="selectedItems"
    :class="[stretch ? 'd-flex' : '']"
    >
    <v-item 
      v-for="(item, index) in options"
      :key="index"
      :value="item.key"
      v-slot="{ isSelected, toggle }"
    >
      <v-card
        :color="isSelected ? 'primary' : 'white'"
        :class="[
          'd-inline-flex align-center item px-4 mt-2', 
          stretch ? 'flex-grow-1' : '',
          element_class,
          index != (options.length-1) ? 'mr-2' : '', 
          isSelected ? 'selected' : 'border']"
        flat
        :disabled="disabled ? (item.key == 'ALL' ? false : true) : false"
        @click="toggle"
        v-if="showOthers || isSelected"
      >
        <div
          class="text-option flex-grow-1 text-center text-capitalize py-2"
          v-html="formatEntry($t(`${transPath}${item.key}`))"
        >
        </div>
      </v-card>
    </v-item>
  </v-item-group>
</template>

<script>
import { computed } from 'vue'
export default {
  props: { 
    multiple: Boolean,
    disabled: Boolean,
    modelValue: null,
    options: Array,
    name: String,
    transPath: String,
    stretch: {
      type: Boolean,
      default: false
    },
    showOthers: {
      type: Boolean,
      default: true
    },
    element_class: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) { 
    const selectedItems = computed({ 
      get: () => props.modelValue, 
      set: (value) => emit('update:modelValue', value)
    }) 

    return { 
      selectedItems,
    } 
  },
  methods: {
    formatEntry(entry) {
      // format silhouette
      if(this.transPath && this.transPath.startsWith('phenotype.silhouette')) {
        const main = entry.match(/([^\s]+)/)[0]; // match first word up to whitespace
        const sub = entry.match(/\((.*?)\)/)[0]; // match words in parentheses
        return `<div class="silhouette-entry"
        <span class="main-entry">${main}</span><br>
        <span class="sub-entry">${sub}</span>
        `
      } else {
        return entry;
      }
    }
  }
};
</script>

<style lang="scss">
// NOT SCOPED, because v-html can't be styled using
// scoped styles, insted we introduce very specific
// selectors only for this exact entry
.silhouette-entry {
  min-width: 80px;
  .sub-entry {
    font-size: 10px;
    color: $nsb-disabled-text;
    line-height: 12px;
  }
}
.selected {
  .sub-entry {
    color: $ds-white !important;
  }
}
</style>

<style lang="scss" scoped>
  .text-option {
    @include nsb-font-container;
    font-size: 14px;
    line-height: 23px;
  }
  .item {
    min-height: 40px;
  }
  .v-card {
    box-sizing: border-box;
  }
  .selected {
    border: 0 !important;
    padding: 1px 17px 1px 17px !important;
    .text-option {
      color: $ds-white !important;
    }
  }
  .border {
    border: 1px solid $ds-secondary-300 !important;
  }
</style>
